var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"table-icon tooltip",class:{ 'is-busy': _vm.isLoading },attrs:{"data-tooltip":"Play Playlist"},on:{"click":_vm.playPlaylist}},[_c('IconPlay')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }